import React from "react";
import { useMessageSource } from "react-message-source";
import FlowStepper from "../../../../../ui/layout/page/stepper";
import { ApplicationChapterId, ApplicationFlowSteps } from "../types";
import { useFeatureToggles } from "../../../../../pages/shared/hooks/useFeatureToggles";
import { Feature } from "../../../../../context/types";

interface Props {
  activeChapterId: ApplicationChapterId;
}

export default function AdditionalCardApplicationFlowStepper({
  activeChapterId,
}: Props): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const canUseAttachmentUpload = useFeatureToggles(Feature.ATTACHMENT_UPLOAD);

  const chapters = [
    {
      id: ApplicationChapterId.Cardholder,
      firstStep: ApplicationFlowSteps.CARDHOLDER,
      title: getMessage("BasicAccountApplicationChapter.CARDHOLDER"),
    },
    {
      id: ApplicationChapterId.SignatoriesAndAppFinalization,
      firstStep: ApplicationFlowSteps.CHOOSE_SIGNATORIES,
      title: getMessage("BasicAccountApplicationChapter.SUMMARY"),
    },
  ];

  if (
    canUseAttachmentUpload &&
    activeChapterId === ApplicationChapterId.UploadAttachments
  ) {
    chapters.push({
      id: ApplicationChapterId.UploadAttachments,
      firstStep: ApplicationFlowSteps.UPLOAD_ATTACHMENTS,
      title: getMessage("BasicAccountApplicationChapter.ATTACHMENT_UPLOAD"),
    });
  }

  return <FlowStepper chapters={chapters} activeChapterId={activeChapterId} />;
}
